import Vue from 'vue'
import Vuex from 'vuex'
import constants from './modules/constants'
import globals from './modules/globals'
import user from './modules/user'
import story from './modules/story'
import storyPublicationRule from './modules/storyPublicationRule'
import topic from './modules/topic'
import author from './modules/author'
import tag from './modules/tag'
import contents from './modules/contents'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    constants,
    globals,
    user,
    story,
    storyPublicationRule,
    topic,
    author,
    tag,
    contents
  },
  strict: debug
})
